import "./UpChevron.scss";

const UpChevron = () => {
    return (
        <span className="up-chevron">&laquo;</span>
    )
}

export default UpChevron;